<template>
  <div>
    <!-- Upload View -->
    <div class="upload-main" v-if="!selectedFile" @dragover.prevent @drop.prevent="handleDrop">
      <h2 class="upload-title-outside">Click. Drag. Done.</h2>
      <div class="upload-box">
        <div class="upload-content">
          <img :src="uploadIcon" alt="Upload" class="upload-icon" />
          <p class="upload-text">
            <strong>Drag and drop file here</strong><br />
            <span class="upload-subtext">Limit 200MB per file • PDF</span>
          </p>
          <button class="upload-button" @click="browseFiles">Browse Files</button>
          <input type="file" ref="file" @change="handleFileUpload" hidden />
        </div>
      </div>
    </div>

    <!-- PDF Preview View -->
    <div v-else class="pdf-preview">
      <!-- Top Bar -->
      <div class="top-bar">
        <div class="file-info">
          <img
            :src="require('../../assets/Images/FDPal/export-document.svg')"
            alt="Document Icon"
            class="file-icon"
          />
          <span class="file-name">{{ selectedFile.name }}</span>
          <span class="file-size">{{ (selectedFile.size / 1024).toFixed(1) }}KB</span>
        </div>
        <button class="reset-button" @click="resetFile">✖</button>
      </div>

      <!-- PDF Preview -->
      <div class="pdf-document">
        <iframe
          :src="pdfUrl"
          type="application/pdf"
          style="width: 100%; height: 100%; border: none;"
          frameborder="0"
        ></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import { PDFDocument } from "pdf-lib";

export default {
  props: {
    uploadedFile: {
      type: File,
      default: null,
    },
  },
  data() {
    return {
      selectedFile: null,
      pdfUrl: null,
      uploadIcon: require("../../assets/Images/FDPal/document-download.svg"),
    };
  },
  watch: {
    uploadedFile: {
      immediate: true,
      async handler(newFile) {
        if (newFile) {
          const base64PDF = await this.readFileAsBase64(newFile);
          await this.setPdfWithTitle(newFile.name, base64PDF, newFile);
        }
      }
    }
  },
  methods: {
    browseFiles() {
      this.$refs.file.click();
    },
    async setPdfWithTitle(name, base64, file) {
      const byteString = atob(base64.split(",")[1]);
      const ab = new ArrayBuffer(byteString.length);
      const ia = new Uint8Array(ab);
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }

      const pdfDoc = await PDFDocument.load(ab);
      pdfDoc.setTitle(name);
      const modifiedPdfBytes = await pdfDoc.save();
      const blob = new Blob([modifiedPdfBytes], { type: "application/pdf" });
      this.pdfUrl = URL.createObjectURL(blob);
      this.selectedFile = {
        name: file?.name,
        size: file?.size,
      };
      this.$emit("file-uploaded", file);
    },
    async handleFileUpload(event) {
      const file = event.target.files[0];
      if (file && file.type === "application/pdf") {
        const base64PDF = await this.readFileAsBase64(file);
        await this.setPdfWithTitle(file.name, base64PDF, file);
      } else {
        alert("Please upload a valid PDF file.");
      }
    },
    async handleDrop(event) {
      const file = event.dataTransfer.files[0];
      if (file && file.type === "application/pdf") {
        const base64PDF = await this.readFileAsBase64(file);
        await this.setPdfWithTitle(file.name, base64PDF, file);
      } else {
        alert("Please drop a valid PDF file.");
      }
    },
    readFileAsBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
    },
    resetFile() {
      this.selectedFile = null;
      this.pdfUrl = null;
      this.$emit("file-uploaded", null);
    },
  },
};
</script>



<style scoped>
.upload-main {
  margin-top: 200px;
}
.upload-title-outside {
  font-size: 19.50px;
  font-weight: 600;
  color: #6b7280;
  text-align: center;
  margin-bottom: 20px;
}
.upload-box {
  width: 620px;
  height: 239px;
  border: 2px dashed #d1d5db;
  border-radius: 6px;
  padding: 32px 24px;
  margin: 0 auto;
  background-color: #f9fafb;
  display: flex;
  justify-content: center;
  align-items: center;
}
.upload-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
}
.upload-icon {
  width: 32px;
  height: 32px;
}
.upload-text {
  font-size: 13.50px;
  color: #374151;
  text-align: center;
}
.upload-subtext {
  font-size: 12.50px;
  color: #9ca3af;
}
.upload-button {
  width: 528px;
  height: 32px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  background-color: white;
  cursor: pointer;
  font-weight: 500;
}
.top-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f9fafb;
  padding: 8px 12px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  margin-bottom: 12px;
}
.file-info {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13.50px;
  color: #374151;
}
.file-icon {
  width: 20px;
  height: 20px;
}
.file-name {
  font-weight: 500;
}
.file-size {
  background-color: #e5e7eb;
  color: #4b5563;
  font-size: 11.50px;
  padding: 2px 6px;
  border-radius: 4px;
}
.reset-button {
  background-color: transparent;
  color: #9ca3af;
  border: none;
  cursor: pointer;
  font-size: 17.50px;
}
.pdf-document {
  width: 100%;
  height: 700px;
  overflow: auto;
}
</style>
